// extracted by mini-css-extract-plugin
export default {"content":"poster-editing-video-options-module__content--Dvnep"};